import { createIcon } from '@chakra-ui/icons';

export const Close = createIcon({
  displayName: 'Close',
  viewBox: '0 0 24 24',
  d: 'M24 2.49724L14.4972 12L24 21.5028L21.5028 24L12 14.4972L2.49724 24L0 21.5028L9.50276 12L0 2.49724L2.49724 0L12 9.50276L21.5028 0L24 2.49724Z',
});
